import React, { useEffect, useState } from "react";
import "./Header.css";
import ButtonPrimary from "../UI/ButtonPrimary";
import HiddenLinkMenu from "../UI/HiddenLinkMenu";
import { Link } from "react-router-dom";
import HeaderData from "../../data/HeaderData.json";

function Header() {
  const [hiddenMenuStatus, setHiddenMenuStatus] = useState({
    hamroBare: false,
    sewaHaru: false,
  });
  // This is only for the mobile devides as this state can't be modified when screen size is large
  const [menuStatus, menuStatusHandler] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const windowWidthHandler = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", windowWidthHandler);

    return () => {
      window.removeEventListener("resize", windowWidthHandler);
    };
  }, []);

  useEffect(() => {
    if (windowWidth > 750) {
      menuStatusHandler(true);
    } else if (windowWidth <= 750) {
      menuStatusHandler(false);
    }
  }, [windowWidth]);

  function turnOnHiddenMenu(e) {
    if (windowWidth <= 750) return;
    if (this === "hamroBare") {
      setHiddenMenuStatus({ hamroBare: true, sewaHaru: false });
    } else if (this === "sewaharu") {
      setHiddenMenuStatus({ hamroBare: false, sewaHaru: true });
    }
  }

  function turnOffHiddenMenu(e) {
    if (windowWidth <= 750) return;
    if (this === "hamroBare") {
      setHiddenMenuStatus({ hamroBare: false, sewaHaru: false });
    } else if (this === "sewaharu") {
      setHiddenMenuStatus({ hamroBare: false, sewaHaru: false });
    }
  }

  function hiddenMenuClickHanlder() {
    if (windowWidth > 750) return;
    if (this === "hamroBare") {
      if (hiddenMenuStatus.hamroBare) {
        setHiddenMenuStatus({ hamroBare: false, sewaHaru: false });
      } else {
        setHiddenMenuStatus({ hamroBare: true, sewaHaru: false });
      }
    } else if (this === "sewaharu") {
      if (hiddenMenuStatus.sewaHaru) {
        setHiddenMenuStatus({ hamroBare: false, sewaHaru: false });
      } else {
        setHiddenMenuStatus({ hamroBare: false, sewaHaru: true });
      }
    }
  }

  function mobileMenuHandler() {
    if (this === "open") menuStatusHandler(true);
    else if (this === "close") menuStatusHandler(false);
  }

  function LinkClickHandler() {
    if (windowWidth > 750) return;
    menuStatusHandler(false);
  }

  return (
    <header className="header">
      {/* Tittle Box means logo and company name box  */}
      <div className="header__tittle-box">
        <div className="header__logo-box">
          <img
            src="assets/images/logo.png"
            alt="Logo of Swawalambhi Cooperative"
          />
        </div>
        <div className="header__heading">
          <h1>
            श्री स्वावलम्बी बचत तथा <br></br> ऋण सहकारी संस्था
          </h1>
        </div>
      </div>
      {menuStatus && (
        <div className="header__menu-bar">
          {/* Link Box means the hyper links in header  */}
          <ul className="header__link-list">
            <li className="header__link-list-item">
              <Link className="header__link" to="/" onClick={LinkClickHandler}>
                गृह
              </Link>
            </li>
            <li className="header__link-list-item">
              <div
                className="header__link"
                id="header__link-hamroBare"
                onMouseEnter={turnOnHiddenMenu.bind("hamroBare")}
                onMouseLeave={turnOffHiddenMenu.bind("hamroBare")}
                onClick={hiddenMenuClickHanlder.bind("hamroBare")}
              >
                हाम्रो बारे
                {hiddenMenuStatus.hamroBare ? (
                  <img src="assets/icons/chevron-up.svg" alt="Down arrow" />
                ) : (
                  <img src="assets/icons/chevron-down.svg" alt="Down arrow" />
                )}
                {hiddenMenuStatus.hamroBare && (
                  <HiddenLinkMenu
                    data={HeaderData.hamroBareData}
                    onClick={LinkClickHandler}
                  />
                )}
              </div>
            </li>
            <li id="header__link-hamroBare" className="header__link-list-item">
              <div
                className="header__link"
                href="#"
                onMouseEnter={turnOnHiddenMenu.bind("sewaharu")}
                id="header__link-sewaharu"
                onMouseLeave={turnOffHiddenMenu.bind("sewaharu")}
                onClick={hiddenMenuClickHanlder.bind("sewaharu")}
              >
                सेवाहरु
                {hiddenMenuStatus.sewaHaru ? (
                  <img src="assets/icons/chevron-up.svg" alt="Down arrow" />
                ) : (
                  <img src="assets/icons/chevron-down.svg" alt="Down arrow" />
                )}
                {hiddenMenuStatus.sewaHaru && (
                  <HiddenLinkMenu
                    data={HeaderData.sewaHaruData}
                    onClick={LinkClickHandler}
                  />
                )}
              </div>
            </li>
            <li className="header__link-list-item">
              <Link
                className="header__link"
                to="/download"
                onClick={LinkClickHandler}
              >
                डाउनलोडहरू
              </Link>
            </li>
            <li className="header__link-list-item">
              <Link
                className="header__link"
                to="/suchana"
                onClick={LinkClickHandler}
              >
                सुचनाहरु
              </Link>
            </li>
            <li className="header__link-list-item">
              <Link
                className="header__link"
                to="/awasar"
                onClick={LinkClickHandler}
              >
                अवसर
              </Link>
            </li>
            <li className="header__link-list-item">
              <Link
                className="header__link"
                to="/gallery"
                onClick={LinkClickHandler}
              >
                गेलरी
              </Link>
            </li>
          </ul>
          <div />
          <ButtonPrimary
            tittle="सम्पर्क"
            to="/contact"
            onClick={LinkClickHandler}
          />
        </div>
      )}
      <div className="header__mobile-menu">
        {!menuStatus ? (
          <img
            src="assets/icons/hamburger.svg"
            alt="Hamburger Icon"
            className="header__mobile-menu-icon"
            onClick={mobileMenuHandler.bind("open")}
          />
        ) : (
          <img
            src="assets/icons/close.svg"
            alt="Close Icon"
            className="header__mobile-menu-icon"
            id="header__mobile-menu-icon--close"
            onClick={mobileMenuHandler.bind("close")}
          />
        )}
      </div>
    </header>
  );
}

export default Header;
